import type { AgentChatEntry, AgentPublishedDraftResult } from './types';

type DraftResult = Extract<AgentChatEntry, { role: 'draft-result' }>;

/** Historical outputs never borrow the current draft's name or another entity's application state. */
export const buildResultRail = (entries: AgentChatEntry[]) => {
    const publications = new Map<number, AgentPublishedDraftResult>();
    const seen = new Set<string>();
    const resultOutputs: DraftResult[] = [];
    for (const entry of entries) {
        if (entry.role === 'agent') {
            for (const item of entry.turn.publishedDrafts ?? []) publications.set(item.draftId, item);
        }
        if (entry.role !== 'draft-result' || entry.draftId == null) continue;
        const key = `${entry.draftId}:${entry.resultNumber}`;
        if (seen.has(key)) continue;
        seen.add(key);
        resultOutputs.push(entry);
    }
    const statuses = new Map<string, 'draft' | 'created' | 'unused'>();
    const latestAppliedResults = new Map<number, DraftResult>();
    for (const result of resultOutputs) {
        const appliedRevision = publications.get(result.draftId!)?.appliedRevisionNumber;
        if (appliedRevision != null && result.revisionNumber != null && result.revisionNumber <= appliedRevision) {
            latestAppliedResults.set(result.draftId!, result);
        }
    }
    for (const result of resultOutputs) {
        const publication = publications.get(result.draftId!);
        let status: 'draft' | 'created' | 'unused' = 'draft';
        if (publication?.appliedRevisionNumber != null && result.revisionNumber != null && result.revisionNumber <= publication.appliedRevisionNumber) {
            status = 'created';
            if (latestAppliedResults.get(result.draftId!)?.id !== result.id) status = 'unused';
        }
        statuses.set(result.id, status);
    }
    return { resultOutputs, statuses };
};
